import { SET_PROJECT_DETAILS, SET_INTAKE_PROJECT_DETAILS, SET_PROJECT_LOADING, SET_PROJECT_ERROR } from '../actionTypes/projectActionTypes';

const initialState = {
  projectDetails: null, // Store project details here
  intakeProjectDetails: null,
  loading: false,       // Loading state
  error: null,          // Error state
};

const projectReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: action.payload,
      };
    case SET_INTAKE_PROJECT_DETAILS:
        return {
          ...state,
          intakeProjectDetails: action.payload,
    };
    case SET_PROJECT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_PROJECT_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default projectReducer;
